import React from 'react';
import { bonuses } from '../data/bonuses';
import { FieldDiamond } from './FieldDiamond';
const bands = ['bg-gold', 'bg-clay', 'bg-green', 'bg-gold', 'bg-clay'];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-21" data-mp="avv308cxxatj">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-22" data-mp="fu6bofri1fa6">
        <div className="text-center" data-id="element-23" data-mp="fsbqr1g89n63">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-24" data-mp="1un4pqafc9zg">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-4xl sm:text-5xl" data-id="element-25" data-mp="5wruuf1nyohc">
            Five instant-use <span className="text-gold" data-id="element-26" data-mp="3t1rayiyqvs6t">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-27" data-mp="1mai1ntk63quo">
            The volumes give you the season. These five clear the stuff around
            it &mdash; helpers, rules, the scorebook, gear and the jargon &mdash;
            so nothing stops you from using it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-28" data-mp="3dg4ygvc5g0jo">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`clip-corner flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-29" data-mp="3r6zzjlgepdcp" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-square w-full border-b border-navy-line object-cover" data-id="element-30" data-mp="38g8vmzf6uf5p" /> : <div className="relative flex aspect-[4/3] w-full flex-col overflow-hidden border-b border-navy-line bg-navy-deep" data-id="element-31" data-mp="irq1qpjjuuaq">
                  <span className={`h-2 w-full ${bands[i]}`} data-id="element-32" data-mp="3ciekez4q7mwz" />
                  <FieldDiamond className="pointer-events-none absolute -bottom-10 -right-10 h-52 w-52 text-ice/10" data-id="element-33" data-mp="3hh81t2n4vy2f" />
                  <div className="relative flex flex-1 flex-col justify-center px-6" data-id="element-34" data-mp="3lkw9rmfogvo7">
                    <span className="font-display text-xs tracking-[2px] text-gold" data-id="element-35" data-mp="3qixoxw9zgaue">
                      Bonus {bonus.number}
                    </span>
                    <span className="mt-2 max-w-[85%] font-display text-3xl leading-[1] text-white" data-id="element-36" data-mp="2tqlujdkyehth">
                      {bonus.title}
                    </span>
                  </div>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-37" data-mp="37jjwjirwj860">
                <div className="flex flex-wrap items-center gap-2" data-id="element-38" data-mp="37leeqpbsgm6e">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-39" data-mp="2a57l8qmrzola">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-40" data-mp="27jztrezylj64">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-41" data-mp="1xlts8yi2ef1s">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-42" data-mp="1tj6y2qxx8i1f">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}